import httpClient from "../utils/httpClient";

export const UserProfileData = async () => {
    const response = await httpClient.post("/user/get-profile", {});
    return response.data;
};

export const updateProfile = async (userData) => {
    const response = await httpClient.post('/User/update-profile', userData);
    return response.data;
};

export const uploadProfileImage = async (requestParams) => {
    const response = await httpClient.post('/User/uploadLedgerImage', requestParams);
    return response.data;
};

